import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";

const Sidebar = ({ openSidebar, setOpenSidebar }) => {
  const navBarItems = [
    { lbl: "Comprar", slug: "/comprar" },
    { lbl: "Vender", slug: "/vender" },
    { lbl: "Quienes somos", slug: "/quienes" },
    { lbl: "Marketplace", slug: "/marketplace" },
    { lbl: "Club", slug: "/club" },
    { lbl: "FAQs", slug: "/faqs" },
    { lbl: "Contacto", slug: "/contacto" },
  ];

  useEffect(async () => {
    document.body.addEventListener("click", () => {
      document.body.style.overflowY = "auto";
      setOpenSidebar(false);
    });
  }, []);

  return (
    <div
      className={`sidebar-s fixed rel anim ${openSidebar ? "show" : "hide"}`}
    >
      <div
        className={`side-block flex col anim ${openSidebar ? "show" : "hide"}`}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="hdr flex items-center justify-center">
          <Link
            to="/"
            onClick={(e) => {
              setOpenSidebar(false);
            }}
          >
            <img src="./images/logo.svg" className="logo-img" />
          </Link>
          <div
            className="icon-close flex aic jc"
            onClick={(e) => {
              setOpenSidebar(false);
            }}
          >
            {/* <CrossIcon /> */}
          </div>
        </div>
        <div>
          <div className="items flex aic flex-col">
            {navBarItems.map((item, index) => (
              <Link
                key={index}
                exact
                to={`${item.slug}`}
                className={`list-item flex `}
                onClick={(e) => {
                  setOpenSidebar(false);
                }}
              >
                {/* <div className="icon flex items-start justify-center mr-3">
                  {item.icon}
                </div> */}
                <div className="li cfff font">{item.lbl}</div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
